import { useEffect } from "react";
import { useRouter } from "next/router";
import type { QueryClient } from "@tanstack/react-query";
import { bindLoginSupersededHandler } from "src/domains/shared/utils/exclusiveLogin/loginSupersededHandler";

/**
 * 밀려남 단일 처리기(`handleLoginSuperseded`)에 앱 의존 — 라우터 이동(`router.replace`)과 쿼리 캐시 비우기
 * (`queryClient.clear`) — 를 주입한다 (design D7). 마운트 동안 주입하고 언마운트 때 거둔다. `_app` 의 `MyApp` 이
 * 한 번 부른다.
 *
 * 감지 경로(fetch 관문·열린 화면 감시자·다른 탭 신호)와 무관하게 처리기는 이 주입이 있어야 캐시를 비우고
 * 종착지(로그인 화면, 로그아웃 뒤면 홈)로 옮긴다. 주입 전에 시작된 처리는 로그아웃까지 진행한 뒤 주입을 기다린다.
 *
 * `queryClient` 를 인자로 받는다 — `MyApp` 은 `QueryClientProvider` 바깥이라 `useQueryClient()` 를 쓸 수 없다.
 */
export function useBindLoginSupersededHandler(queryClient: QueryClient): void {
  const router = useRouter();

  useEffect(
    () =>
      bindLoginSupersededHandler({
        replaceRoute: (url) => router.replace(url),
        clearQueryCache: () => queryClient.clear(),
      }),
    [router, queryClient]
  );
}
